import assign from 'lodash/assign';
import reduce from 'lodash/reduce';

const actions = [
    'UPDATE_USER_INFO',
    'UPDATE_APP',
    'SET_CURRENT_AREA',
    'UPDATE_PAYMENT_INFO',
    'UPDATE_PAYMENT_SETTINGS',
    'ADD_DEBUG',
    'SET_CURRENT_LISTING',
    'EDIT_PROPERTY_RATING',
    'EDIT_PROPERTY_REVIEW',
    'EDIT_MANAGER_RATING',
    'EDIT_MANAGER_REVIEW',
    'SET_RATING_AND_REVIEW_LISTING',
    'EDIT_TENANT_TYPE',
    'EDIT_LISTINGS',
    'SET_AUTO_COMPLETE_ADDRESS_LIST'
];

const dispatchConstants = reduce(actions, (accumulator, value) => {
    accumulator[value] = value;
    return accumulator;
}, {});

const valueConstants = {
    GA_SCOPE_PAGE: 3,
    GA_SCOPE_SESSION: 2,
    FETCH_ALL_COMPONENTS: 'all'
};

const constants = assign({}, dispatchConstants, valueConstants);

export default constants;